export enum MessageReasonType {
  INITIALIZATION = 'INITIALIZATION',
  TIMEOUT = 'TIMEOUT',
  RETRY = 'RETRY',
  USER_INPUT = 'USER_INPUT',
  SELECTION = 'SELECTION',
  CART_CHANGED = 'CART_CHANGED',
  JWT = 'JWT',
  ERROR = 'ERROR',
  DELIVERED = 'DELIVERED',
  MODEL_RESPONSE = 'MODEL_RESPONSE',
  CROSS_SALE = 'CROSS_SALE',
}
